<section class="container py-5">
    <!-- 1. Anschrift -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-primary bg-icon">location_on</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Anschrift</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Die vollständige Postadresse jedes Unternehmens, inklusive Straße, Hausnummer, Postleitzahl und Ort.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Nutzen Sie die Adressen für postalische Mailings, zur Planung von Vertriebsaktionen vor Ort oder für präzise Standortanalysen (z. B. Geocoding). Ideal, wenn Sie neue Regionen erschließen oder Einzugsgebiete bestimmen möchten.</div>
            </div>
        </div>
    </div>

    <!-- 2. Website -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-info bg-icon">language</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Website</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Den Link zur offiziellen Firmenwebseite.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Direkter Zugriff auf alle zentralen Informationen zu Produkten, Leistungen und Ansprechpartnern. Sie können gezielt potenzielle Kunden analysieren oder eigene Vertriebsteams mit vorbereiteten Hintergrundinfos ausstatten.</div>
            </div>
        </div>
    </div>

    <!-- 3. Google Rating -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-warning bg-icon">star_rate</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Google Rating</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Die aktuelle durchschnittliche Google-Sternebewertung des Unternehmens.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Erkennen Sie auf einen Blick, wie gut das Unternehmen bei Kunden ankommt. Identifizieren Sie schnell besonders gefragte oder vertrauenswürdige Firmen und richten Sie Ihr Marketing gezielt an Unternehmen mit hohem oder auffälligem Kundenfeedback.</div>
            </div>
        </div>
    </div>

    <!-- 4. E-Mail -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-danger bg-icon">email</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">E-Mail</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Verifizierte, öffentlich verfügbare Kontakt-E-Mail-Adressen.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Sparen Sie sich die zeitaufwändige Recherche: Sie erhalten direkt nutzbare Adressen für effizientes E-Mail-Marketing, Outreach-Kampagnen oder Support-Anfragen. Ihre Kontaktaufnahme landet direkt beim richtigen Ansprechpartner.</div>
            </div>
        </div>
    </div>

    <!-- 5. Instagram-Account -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-pink bg-icon">camera_alt</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Instagram-Account</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Den Link zum offiziellen Instagram-Profil des Unternehmens.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Analysieren Sie die Social-Media-Aktivität, Reichweite und Markenwahrnehmung der Zielunternehmen. Perfekt für Agenturen, die Influencer-Reichweite oder visuelles Branding vergleichen möchten.</div>
            </div>
        </div>
    </div>

    <!-- 6. Facebook-Account -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-primary bg-icon">thumb_up</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Facebook-Account</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Den Link zur Facebook-Seite des Unternehmens.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Greifen Sie auf Community-Interaktionen, Posts und Bewertungen zu. Sie können gezielt Unternehmen für Social-Media-Kooperationen oder Werbekampagnen auswählen und deren Reichweite beurteilen.</div>
            </div>
        </div>
    </div>

    <!-- 7. LinkedIn-Profil -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-success bg-icon">business_center</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">LinkedIn-Profil</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Den Link zur offiziellen LinkedIn-Unternehmensseite.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Ideal für B2B-Marketing und Recruiting: Sie erhalten Einblicke in die Mitarbeiterstruktur, offene Stellen und Branchenpositionierung. Finden Sie schnell passende Partner oder potenzielle Kandidaten.</div>
            </div>
        </div>
    </div>

    <!-- 8. Impressum -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-secondary bg-icon">gavel</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Impressum</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Den Link zur rechtlichen Anbieterinformation gemäß § 5 TMG.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Erfüllen Sie alle rechtlichen Anforderungen für Ihre Kontaktaufnahme oder Recherche. Vertrauen und Transparenz sind so jederzeit gewährleistet.</div>
            </div>
        </div>
    </div>

    <!-- 9. Job-Link -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-info bg-icon">work_outline</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Job-Link</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Den direkten Link zur Karriereseite oder Jobübersicht des Unternehmens.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Sehen Sie auf einen Blick, welche Firmen wachsen und Mitarbeiter suchen. Nutzen Sie die Info für gezieltes Recruiting oder Kooperationen im HR-Bereich.</div>
            </div>
        </div>
    </div>

    <!-- 10. Kontakt -->
    <div class="row align-items-center mb-5 feature-row rounded shadow-sm py-4 px-3">
        <div class="col-auto d-flex align-items-center justify-content-center">
            <span class="material-icons fs-1 text-success bg-icon">support_agent</span>
        </div>
        <div class="col">
            <h4 class="fw-bold mb-2">Kontakt</h4>
            <div class="row mb-1">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Was erhalten Sie?</span></div>
                <div class="col-12">Den Link zum Kontaktformular, Support-Portal oder Live-Chat.</div>
            </div>
            <div class="row">
                <div class="col-12"><span class="badge bg-light text-dark mb-1">Ihr Vorteil:</span></div>
                <div class="col-12">Schnelle und unkomplizierte Kontaktaufnahme, häufig inklusive Telefonnummern und Servicezeiten – optimal für alle, die sofort persönliche Ansprechpartner erreichen möchten.</div>
            </div>
        </div>
    </div>
</section>